import React from 'react';
import { Container } from 'react-bootstrap';
import { FileImport } from '../../components/common/FileImport';
import { ordensProducaoImportService } from '../../services/importService';

export const OrdensProducaoImportPage: React.FC = () => {
  return (
    <Container fluid className="py-4">
      <FileImport
        tipo="ordens-producao"
        title="Importação de Ordens de Produção"
        description="Importe ordens de produção em lote através de arquivos CSV ou Excel. O arquivo deve conter: codigo, produto, data_inicio_prevista, data_fim_prevista, quantidade_planejada, etc."
        onImport={ordensProducaoImportService.import}
        templateUrl="/templates/Producao.xlsx"
      />
    </Container>
  );
};
